module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner-center"
  }, [_c('div', {
    staticClass: "center-container"
  }, [_c('div', {
    staticClass: "stable-quicken-box"
  }, [_c('div', {
    staticClass: "stable-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "stable-item-content"
  }, [_c('h2', {
    staticClass: "stable-title"
  }, [_vm._v(_vm._s(_vm.$t("visitglobal")))]), _vm._v(" "), _c('p', {
    staticClass: "stable-text"
  }, [_vm._v(_vm._s(_vm.$t("visitcontent1")))])])]), _vm._v(" "), _c('div', {
    staticClass: "stable-item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stable-item-content"
  }, [_c('h2', {
    staticClass: "stable-title"
  }, [_vm._v(_vm._s(_vm.$t("privacyprotection")))]), _vm._v(" "), _c('p', {
    staticClass: "stable-text"
  }, [_vm._v(_vm._s(_vm.$t("privacycontent1")))])])]), _vm._v(" "), _c('div', {
    staticClass: "stable-item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "stable-item-content"
  }, [_c('h2', {
    staticClass: "stable-title"
  }, [_vm._v(_vm._s(_vm.$t("support")))]), _vm._v(" "), _c('p', {
    staticClass: "stable-text"
  }, [_vm._v(_vm._s(_vm.$t("supportDes")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "special-box"
  }, [_c('div', {
    staticClass: "special-title-box"
  }, [_c('div', {
    staticClass: "special-title"
  }, [_vm._v(_vm._s(_vm.$t("specialTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "title-underline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "special-item-box"
  }, _vm._l((_vm.$t('specialItem')), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "special-item"
    }, [_c('div', {
      staticClass: "item-title-box"
    }, [_c('div', {
      staticClass: "item-ic"
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/newhome_img/ic_" + (index + 1) + ".svg"),
        "alt": "",
        "srcset": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "item-content"
    }, [_vm._v(_vm._s(item.des))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "get-plex-box shadow-btn"
  }, [_c('router-link', {
    staticClass: "get-plex",
    attrs: {
      "to": !_vm.$store.state.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("getPlex")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "global-box"
  }, [_c('div', {
    staticClass: "global-title-box"
  }, [_c('div', {
    staticClass: "global-title"
  }, [_vm._v(_vm._s(_vm.$t("globalTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "global-des"
  }, [_vm._v(_vm._s(_vm.$t("globalDes")))]), _vm._v(" "), _c('div', {
    staticClass: "title-underline"
  })]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "user-comments-box"
  }, [_c('div', {
    staticClass: "comments-title-box"
  }, [_c('div', {
    staticClass: "comments-title"
  }, [_vm._v(_vm._s(_vm.$t("evaluate")))]), _vm._v(" "), _c('div', {
    staticClass: "title-underline"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "swipercom"
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.$t('swiperItem')), function(item, index) {
    return _c('div', {
      key: item.imgSrc + index,
      class: ("swiper-slide swiper-slide" + (index + 1))
    }, [_c('div', {
      staticClass: "swiper-item"
    }, [_c('div', {
      staticClass: "item-user"
    }, [_c('div', {
      staticClass: "user-img"
    }, [_c('img', {
      attrs: {
        "src": ("/static/img/newhome_img/" + (item.imgSrc + (index + 1)) + ".png"),
        "alt": "",
        "srcset": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-box"
    }, [_c('div', {
      staticClass: "user-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "score"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "from"
    }, [_vm._v(_vm._s(_vm.$t("swiperFrom")))])])])]), _vm._v(" "), _c('div', {
      staticClass: "item-content"
    }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "get-plex-box shadow-btn"
  }, [_c('router-link', {
    staticClass: "get-plex",
    attrs: {
      "to": !_vm.$store.state.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("getPlex")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "packages-title-box"
  }, [_c('div', {
    staticClass: "packages-title"
  }, [_vm._v(_vm._s(_vm.$t("enjoy")))]), _vm._v(" "), _c('div', {
    staticClass: "title-underline"
  }), _vm._v(" "), _c('div', {
    staticClass: "days-box"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "days-text"
  }, [_vm._v(_vm._s(_vm.$t("vipAdvantage")))])])])]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "container compatibility"
  }, [_c('div', {
    staticClass: "compatibility-title-box"
  }, [_c('div', {
    staticClass: "compatibility-title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("compatibilityTitle")) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "compatibility-des"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("compatibilityDes")) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content text-center"
  }, [_c('div', {
    staticClass: "download-btn-box"
  }, [_c('router-link', {
    staticClass: "download-btn",
    attrs: {
      "to": "/download"
    }
  }, [_c('div', {
    staticClass: "btn-text"
  }, [_vm._v(_vm._s(_vm.$t("download")))])])], 1), _vm._v(" "), _c('p', {
    staticClass: "download-more-equipment"
  }, [_c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=windows",
      "aria-label": "windows"
    }
  }, [_c('img', {
    staticClass: "download-icon",
    attrs: {
      "src": "/static/img/downloadNew/ic_windows.svg",
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=mac",
      "aria-label": "mac"
    }
  }, [_c('img', {
    staticClass: "download-icon",
    attrs: {
      "src": "/static/img/downloadNew/ic_macos.svg",
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=ios",
      "aria-label": "ios"
    }
  }, [_c('img', {
    staticClass: "download-icon",
    attrs: {
      "src": "/static/img/downloadNew/ic_apple.svg",
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=android",
      "aria-label": "android"
    }
  }, [_c('img', {
    staticClass: "download-icon",
    attrs: {
      "src": "/static/img/downloadNew/ic_android.svg",
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=ubuntu",
      "aria-label": "ubuntu"
    }
  }, [_c('img', {
    staticClass: "download-icon",
    attrs: {
      "src": "/static/img/downloadNew/ic_linux.svg",
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=androidTV",
      "aria-label": "android_tv"
    }
  }, [_c('img', {
    staticClass: "download-icon",
    attrs: {
      "src": "/static/img/downloadNew/ic_androidTV.svg",
      "alt": "",
      "srcset": ""
    }
  })])], 1)])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stable-item-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/newhome_img/img_earth.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stable-item-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/newhome_img/img_safe.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stable-item-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/newhome_img/img_more.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "global-gif"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/newhome_img/map@2x.gif",
      "alt": "",
      "srcset": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star-box"
  }, [_c('div', {
    staticClass: "start"
  }), _vm._v(" "), _c('div', {
    staticClass: "start"
  }), _vm._v(" "), _c('div', {
    staticClass: "start"
  }), _vm._v(" "), _c('div', {
    staticClass: "start"
  }), _vm._v(" "), _c('div', {
    staticClass: "start"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "days-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/newhome_img/ic_7-day.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07bda2d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/homeBodyPc/HomeBodyPc.vue
// module id = 1258
// module chunks = 1